import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 sm:py-32 relative overflow-hidden" style={{
    backgroundColor: '#111118'
  }} data-id="element-10">
      {/* Subtle gradient accent */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at 50% 100%, rgba(249, 115, 22, 0.08) 0%, transparent 50%)'
    }} data-id="element-11" />

      <div className="relative z-10 max-w-3xl mx-auto px-5 sm:px-8 text-center" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-13">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight leading-tight text-white mb-5" data-id="element-14">
            Your Calendar Won't Fix Itself.
          </h2>

          <p className="text-lg sm:text-xl mb-10" style={{
          color: '#d4d4d8'
        }} data-id="element-15">
            Every day you wait is another day of meetings that should have been
            emails.
          </p>

          <motion.a href="https://manosquegeneran.com/cart/48287663194339:1" className="cta-glow inline-flex items-center justify-center px-10 py-5 text-lg font-bold text-white rounded-lg transition-colors duration-200" style={{
          backgroundColor: '#f97316'
        }} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.98
        }} data-id="element-16">
            Get The Scripts Now — $6.39
          </motion.a>

          <p className="mt-5 text-sm" style={{
          color: '#a1a1aa'
        }} data-id="element-17">
            Instant access. 7-day guarantee. Zero meetings required.
          </p>
        </motion.div>
      </div>
    </section>;
}